import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { apiCall } from '../../action/RouterActions';
import ModalUploadFile from '../../component/common/modals/ModalUploadFile';

import '../../component/dump/menuComponents/menuComponents.sass'
import { checkEmail } from '../../component/helpers/tablesFuncHelpers';
import Toggle from 'react-toggle';
import CustomButton from '../../component/CustomButton';

const AddDriver = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'driversPage.addDriver' });
	const { groups, company, drivers, initialData, setPropStates, toggleLoader } = props;

	const [data, setData] = useState({
		first_name: '',
		last_name: '',
		group_id: '',
		card_id: '',
		email: '',
		send_qr_code: false
	});
	const [errMessage, setErrMessage] = useState({
		errfirst_name: '',
		errlast_name: '',
		errcard_id: '',
		erremail: ''
	});
	const [open, setOpen] = useState(false);
	const [driverSaved, setDriverSaved] = useState(false);
	const [showUploadDrivers, setShowUploadDrivers] = useState(false);
	const [fileUploadDrivers, setFileUploadDrivers] = useState(null);
	const [upd, setUpd] = useState(false);

	const handleInputChange = (event) => {
		const { target } = event;
		const { name } = target;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		setData(prevState => ({ ...prevState, [name]: value }));
	};

	const checkForm = (data, e) => {
		const regExp = /^[-+]?[0-9A-Fa-f]+\.?[0-9A-Fa-f]*?$/;

		let error = false;

		Object.keys(data).forEach((key) => {
			if (data[key] === '') {
				error = true;
				if (key === 'email') errMessage[`err${key}`] = t('enterYourEmail');
				if (key === 'first_name') errMessage[`err${key}`] = t('enterYourFirstName');
				if (key === 'last_name') errMessage[`err${key}`] = t('enterYourLastName');
				if (key === 'card_id') errMessage[`err${key}`] = t('enterYourCardID');
			} else if ((key === "first_name" || key === "last_name") && data[key].toString().trim() === '' || (key !== "email" && !/^[a-zA-Z0-9 ]+$/.test(data[key].toString()))) {
				error = true;
				errMessage[`err${key}`] = t('errEnterKey') + key;
			} else if (key === 'card_id' && data.card_id && (data.card_id.length !== 8 || !regExp.test(data.card_id))) {
				error = true;
				errMessage.errcard_id = t('errCardId');
			} else if (key === 'email' && data.email && !checkEmail(data.email)) {
				error = true;
				errMessage.erremail = t('errEmail');
			} else if (key === 'send_qr_code' && !data.email) {
				error = true;
				errMessage.erremail = t('errSendQRCode');
			} else if (errMessage[`err${key}`]) {
				errMessage[`err${key}`] = null;
			}
		})

		setErrMessage(errMessage);
		setUpd(!upd);
		return error;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const { first_name, last_name, group_id, card_id, email, send_qr_code } = data;
		const params = {
			first_name: first_name.trim(),
			last_name: last_name.trim(),
			company_id: company.company_id,
			card_id,
			email
		}
		if (group_id) {
			params.group_id = group_id
		}
		if (send_qr_code) {
			params.send_qr_code = send_qr_code
		}

		const error = checkForm(params, e);
		if (!error) {
			toggleLoader(true);

			apiCall('PUT', '/driver', params)
				.then((res, err) => {
					console.log('handleSubmit res: ', res, err)

					const obj = res.data.response
					setPropStates({
						initialData: [...initialData, obj],
						drivers: [...drivers, obj],
					})
					clearFields();

					toggleLoader(false);
					setDriverSaved(true);
					setOpen(false);
					toastr.success('', t('driverAdded'))
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onSave error: ', error.response, error)
					if (error.response && error.response.status === 404) {
						toastr.error(error.response.data.response.error);
					} else {
						toastr.error(t('unableAddDriver'));
					}
				})
		}
	};

	const displayUploadDrivers = () => {
		setShowUploadDrivers(true);
	};

	const closeUploadDrivers = () => {
		setShowUploadDrivers(false);
	};

	const handleFileChange = (e) => {
		const { value } = e.target;
		const file = e.target.files[0];
		setFileUploadDrivers(file);

		let i;
		if (value.lastIndexOf('\\')) {
			i = value.lastIndexOf('\\') + 1;
		} else {
			i = value.lastIndexOf('/') + 1;
		}
		const filename = value.slice(i);
		const uploaded = document.getElementById('upload-form-label');
		uploaded.innerHTML = filename;
	};

	const handleUploadDrivers = (e) => {
		e.preventDefault()

		if (!fileUploadDrivers) {
			toastr.warning(t('selectCSV/ExcelFile'))
			return
		}

		const params = {
			file: fileUploadDrivers,
			company_id: company.company_id,
		}
		toggleLoader(true);
		apiCall('PUT', '/driver/upload?bell_notifs=true', params)
			.then((res, err) => {
				console.log('handleUploadDrivers res: ', res, err)
				toggleLoader(false);
				toastr.success('', t('toastrFileUploaded'))
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('handleUploadDrivers error: ', error.response, error)

				toastr.error(t('unableUploadDrivers'));
			})
	};

	const clearFields = () => {
		const data = {
			first_name: '',
			last_name: '',
			group_id: '',
			card_id: '',
			email: '',
			send_qr_code: false,
		};

		setData(data);

		setErrMessage({
			errfirst_name: '',
			errlast_name: '',
			errcard_id: '',
			erremail: ''
		});
	};

	const toggleAddBlock = (e) => {
		e.preventDefault();
		setOpen(!open);
		clearFields();
	};

	const { first_name, last_name, group_id, card_id, email, send_qr_code } = data;
	const { errfirst_name, errlast_name, errcard_id, erremail } = errMessage;

	return (
		<div className="add-asset-block">
			<CustomButton variant="secondary-outline" className='rosco-secondary-inverted' onClick={toggleAddBlock}>{open ? t('btnCancel') : driverSaved ? t('btnAddAnotherDriver') : t('btnAddANewDriver')}</CustomButton>
			{open
				&& (
					<div className='three-column-grid'>
						<div className={`${errfirst_name && 'has-error'}`}>
							<label className="control-label">
								{t('labelFirstName')}
							</label>
							<input
								type="text"
								name="first_name"
								className="vehicle-search"
								value={first_name}
								onChange={handleInputChange}
							/>
							{errfirst_name && <span className="help-block">{errfirst_name}</span>}
						</div>

						<div className={`${errlast_name && 'has-error'}`}>
							<label className="control-label">
								{t('labelLastName')}
							</label>
							<input
								type="text"
								name="last_name"
								className="vehicle-search"
								value={last_name}
								onChange={handleInputChange}
							/>
							{errlast_name && <span className="help-block">{errlast_name}</span>}
						</div>

						<div>
							<label htmlFor="user-role" className="control-label">
								{t('labelAssignGroup')}
							</label>
							<select
								placeholder="Select Group"
								className="rosco-select block"
								name="group_id"
								value={group_id}
								onChange={handleInputChange}
							>
								<option value="">{t('optionSelectGroup')}</option>
								{groups.map(({ id, group_name }) => <option key={id} value={id}>{group_name}</option>)}
							</select>
						</div>

						<div className={`${erremail && 'has-error'}`}>
							<label className="control-label">
								{t('labelEmail')}
							</label>
							<input
								type="text"
								name="email"
								className="vehicle-search"
								value={email}
								onChange={handleInputChange}
							/>
							{erremail && <span className="help-block">{erremail}</span>}
						</div>

						<div className={`${errcard_id && 'has-error'}`}>
							<label className="control-label">
								{t('labelCardID')}
							</label>
							<input
								type="text"
								name="card_id"
								className="vehicle-search"
								value={card_id}
								onChange={handleInputChange}
							/>
							{errcard_id && <span className="help-block">{errcard_id}</span>}
						</div>
						<div className='toggles-container'>
							<label className='toggle-wrapper'>
								<Toggle
									name="send_qr_code"
									checked={send_qr_code}
									onChange={handleInputChange}
								/>
								<span className="control-label">
									{t('labelSendQRCode')}
								</span>
							</label>
						</div>
						<div className="first-two-columns">
							<label className="control-label"> </label>
							<div>
								<CustomButton
									className="rosco-primary two-buttons"
									onClick={handleSubmit}
									variant='primary'
								>
									{t('btnAddNewDriver')}
								</CustomButton>

								<CustomButton
									className="rosco-primary-inverted"
									onClick={displayUploadDrivers}
									title={t('titleUploadExcel/CSVFile')}
									variant='primary-outline'
								>
									{t('btnUploadDrivers')}
								</CustomButton>
							</div>
						</div>
					</div>
				)}

			{showUploadDrivers
				&& (
					<ModalUploadFile
						onFileChange={handleFileChange}
						onUploadFile={handleUploadDrivers}
						onHide={closeUploadDrivers}
					/>
				)}
		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(AddDriver);
